﻿/*
 * COMPONENTS FOR OFFERING PAGE SHOULD BE ADDED IN THIS  
 */

import { mapGetters, mapState } from 'vuex';
import AddressLookup from './offeringpage/AddressLookup.js';
import BasketView from './offeringpage/BasketView.js';
import Products from './offeringpage/Products.js';
import VASOffering from './offeringpage/VASOffering.js';
import Carousel from './offeringpage/Carousel.js';
import AddToBasketBtn from './offeringpage/AddToBasketBtn.js';
import SalesLeadModule from './SalesLeadModule.js';
import VASSelectionModal from './offeringpage/VASSelectionModal.js';
import VASLimitModal from './offeringpage/VASLimitModal.js';
import AddressMissingModal from './offeringpage/AddressMissingModal.js';
import AlertModal from './AlertModal.js';

export default {
name: 'offering-page',
template: '#offeringpage-template',
data: () => ({
    fixate: false,
    fixatedAt: 0
}),
components: {
    'addresslookup' : AddressLookup,
    'basketview': BasketView,
    'products': Products,
    'vas-offering' : VASOffering,
    'carousel' : Carousel,
    'add-to-basket-btn' : AddToBasketBtn,
    'sales-lead-module': SalesLeadModule,
    'vas-selection-modal': VASSelectionModal,
    'address-missing-modal': AddressMissingModal,
    'alert-modal': AlertModal,
    'vas-limit-modal': VASLimitModal,
},
computed:
    Object.assign(
        mapState({
            isDoneSearching: state => state.offeringpage.products.isDoneSearching,
            searchBegun: state => state.offeringpage.products.beginProductSearch,
            allProducts: state => state.offeringpage.products.available,
            hasLookupFailure: state => state.offeringpage.addresslookup.failure,
            vasLessAllowed: state => state.offeringpage.vasLessAllowed
        }),
        mapGetters({
            selectedVariant: 'selectedVariant',
        }),
        {
            hasNoProducts() {
                return this.isDoneSearching && !this.allProducts.length;
            },
            showBelow() {
                return this.fixate;
            },
            resetVasSelection() {

            },
        }
    ),
methods: {
        //checkScroll() {
        //    if (document.getElementById('b1')) {
        //        var offsets = document.getElementById('b1').getBoundingClientRect();
        //        var top = offsets.top;
        //        var left = offsets.left;
        //        var scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop; //Supports IE

        //        if(!this.fixate && top <= 0) {
        //            this.fixatedAt = scrollTop;
        //            this.fixate = true;
        //        } else {
        //            if(this.fixatedAt > scrollTop) this.fixate = false;
        //        }
        //        //console.log("fixate: " +  this.fixate + ", top: " + top + ", scrollYop: " + scrollTop);
        //    }
        //}
    },
    mounted: function() {
        //window.addEventListener('scroll', this.checkScroll);
        
        var items = document.querySelectorAll('.footer-bgsvg');
        for (var i = 0; i < items.length; i++) {
            // access to individual element:
            var elem = items[i];
            elem.style.fill = "#FFF";
        }
    }

}